<template>
<div class="main-body">
  <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <form>
      <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-sm-5">
                      <h4 class="card-title mb-0">
                        Shipper Management <small class="text-muted">shippers</small>
                      </h4>
                  </div><!--col-->
              </div><!--row-->

              <div class="row mt-4">
                  <div class="col">
                      <div class="form-group row">
                        <label for="courier_id" class="col-sm-2 col-form-label">{{ $t('shipper.courier_name') }}</label>
                        <div class="col-sm-4">
                          <select class="form-control" v-model="shipper.courier_id">
                            <option :value="shipper.courier_id">{{ shipper.courier_name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="shipper_account" class="col-sm-2 col-form-label">{{ $t('shipper.shipper_account') }}</label>
                        <div class="col-sm-3">
                          <input v-model="shipper.shipper_account" type="text" name="shipper_account" class="form-control">
                        </div>
                        <label for="billing_account" class="col-sm-2 col-form-label">{{ $t('shipper.billing_account') }}</label>
                        <div class="col-sm-3">
                          <input v-model="shipper.billing_account" type="text" name="billing_account" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="duty_account" class="col-sm-2 col-form-label">{{ $t('shipper.duty_account') }}</label>
                        <div class="col-sm-3">
                          <input v-model="shipper.duty_account" type="text" name="duty_account" class="form-control" />
                        </div>
                        <label for="shipper_id" class="col-sm-2 col-form-label">{{ $t('shipper.shipper_id') }}</label>
                        <div class="col-sm-3">
                          <input v-model="shipper.shipper_id" type="text" name="shipper_id" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="shipper_name" class="col-sm-2 col-form-label">{{ $t('shipper.shipper_name') }}</label>
                        <div class="col-sm-3">
                          <input v-model="shipper.shipper_name" type="text" name="shipper_name" class="form-control" />
                        </div>
                        <label for="registered_account" class="col-sm-2 col-form-label">{{ $t('shipper.registered_account') }}</label>
                        <div class="col-sm-3">
                          <input v-model="shipper.registered_account" type="text" name="registered_account" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="address_line1" class="col-sm-2 col-form-label">{{ $t('shipper.address_line1') }}</label>
                        <div class="col-sm-6">
                          <input v-model="shipper.address_line1" type="text" name="address_line1" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="address_line2" class="col-sm-2 col-form-label">{{ $t('shipper.address_line2') }}</label>
                        <div class="col-sm-6">
                          <input v-model="shipper.address_line2" type="text" name="address_line2" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="city" class="col-sm-2 col-form-label">{{ $t('shipper.city') }}</label>
                        <div class="col-sm-3">
                          <input v-model="shipper.city" type="text" name="city" class="form-control" />
                        </div>
                        <label for="postal_code" class="col-sm-2 col-form-label">{{ $t('shipper.postal_code') }}</label>
                        <div class="col-sm-3">
                          <input v-model="shipper.postal_code" type="text" name="postal_code" class="form-control" />
                      </div>
                      </div>
                      <div class="form-group row">
                        <label for="division" class="col-sm-2 col-form-label">{{ $t('shipper.division') }}</label>
                        <div class="col-sm-3">
                          <input v-model="shipper.division" type="text" name="division" class="form-control" />
                        </div>
                        <label for="division_code" class="col-sm-2 col-form-label">{{ $t('shipper.division_code') }}</label>
                        <div class="col-sm-3">
                          <input v-model="shipper.division_code" type="text" name="division_code" class="form-control" />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="country_code" class="col-sm-2 col-form-label">{{ $t('shipper.country_code') }}</label>
                        <div class="col-sm-3">
                          <input v-model="shipper.country_code" type="text" name="country_code" class="form-control" />
                        </div>
                        <label for="country_name" class="col-sm-2 col-form-label">{{ $t('shipper.country_name') }}</label>
                        <div class="col-sm-3">
                          <input v-model="shipper.country_name" type="text" name="country_name" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="contact_person_name" class="col-sm-2 col-form-label">{{ $t('shipper.contact_person') }}</label>
                        <div class="col-sm-3">
                          <input v-model="shipper.contact_person_name" type="text" name="contact_person_name" class="form-control" />
                        </div>
                        <label for="contact_phone" class="col-sm-2 col-form-label">{{ $t('shipper.contact_phone') }}</label>
                        <div class="col-sm-3">
                          <input v-model="shipper.contact_phone" type="text" name="contact_phone" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="status" class="col-sm-2 col-form-label">{{ $t('shipper.status') }}</label>
                        <div class="col-sm-8">
                          <CSwitch class="mx-1" :checked.sync="status" color="primary" variant="outline" shape="pill"/>
                        </div>
                      </div>
                  </div><!--col-->
              </div><!--row-->

              <div slot="footer">
                <div class="row">
                    <div class="col-7">
                        <div class="float-left"></div>
                    </div><!--col-->
                    <div class="col-5">
                        <div class="float-right">
                            <CButton color="submit" size="sm" variant="primary" @click.stop.prevent="handleSubmit">
                              <i class="fa fa-dot-circle-o"></i> {{ $t('shipper.update') }}
                            </CButton>
                        </div>
                    </div><!--col-->
                </div><!--row-->
              </div>
          </div><!--card-body-->
      </div><!--card-->
    </form>
   <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>
<script>
import loadingPanel from '@/components/LoadingPanel'

export default {
  name: 'ShipperEdit',
  components: {
    loadingPanel
  },
  mounted () {
    this.axios.get('/delivery/shipper/' + this.$route.params.id).then(response => {
      this.shipper = response.data
      if (this.shipper.status === 1) {
        this.status = true
      }
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      couriers: [],
      shipper: {
        id: '',
        courier_id: '',
        courier_name: '',
        shipper_account: '',
        billing_account: '',
        duty_account: '',
        shipper_id: '',
        shipper_name: '',
        registered_account: '',
        address_line1: '',
        address_line2: '',
        city: '',
        division: '',
        division_code: '',
        postal_code: '',
        country_code: '',
        contact_person_name: '',
        contact_phone: '',
        status: 0
      },
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      status: false,
      message: ''
    }
  },
  methods: {
    handleSubmit () {
      if (this.shipper.shipper_account) {
        // create shipper
        this.getShipperStatus()
        this.showLoadingPanel = true
        this.axios.put('/delivery/shipper/' + this.shipper.id, this.shipper).then(response => {
          this.showLoadingPanel = false
          this.showAlert('success', this.$t('shipper.success_message'))
          this.message = response.data
        }).catch(error => {
          this.showLoadingPanel = false
          this.showAlert('danger', error.data.message)
        })
      }
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    },
    getShipperStatus () {
      if (this.status) {
        this.shipper.status = 1
      } else {
        this.shipper.status = 0
      }
    }
  }
}
</script>
